export default __webpack_public_path__ + "static/media/anhar-image.d4f552d7.jpg";